// Обработчик для session.switch_success
// Направление: server -> client
import emitter from "../../core/wsEmitter";
import { setSessionDataInState } from "./session.service";
import { setSocketStatus } from "../../../store/slices/app.slice";
import { store } from "../../../store/store";

emitter.on("session.switch_success", (data: any) => {
	store.dispatch(setSocketStatus("online"));
	const { count, messages, ok, previous_session_id, session_id, type } = data;
	// Сохраняем данные в redux
	setSessionDataInState({
		count,
		messages,
		ok,
		previous_session_id,
		session_id,
		type,
	});
});
